export function AmbientOrbs() {
  return (
    <div aria-hidden className="pointer-events-none fixed inset-0 overflow-hidden mix-blend-screen">
      <div className="absolute -top-[10%] -left-[10%] w-[60%] h-[60%] bg-rose-600/10 rounded-full blur-[140px]" />
      <div className="absolute -bottom-[10%] -right-[10%] w-[60%] h-[60%] bg-amber-600/5 rounded-full blur-[140px]" />
      <div className="absolute top-[40%] -right-[20%] w-[40%] h-[40%] bg-rose-900/10 rounded-full blur-[120px]" />
    </div>
  );
}
